module.exports = __webpack_public_path__ + "static/img/new-icon.45e9e0b0.png";